import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';



@Injectable()
export class UtilService {

  constructor(private http: Http) { }

  split(fileToUpload: any) {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    let input = new FormData();
    input.append("file", fileToUpload);

    // return this.http.post(environment.server.url + '/utils/fullname-splitter', input, { headers: headers })
    //   .map(response => response.json())
    //   .catch(this.handleError);




    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(environment.server.url + '/utils/fullname-splitter', input, options)
      .map(response => {
        let fileBlob = response.blob();
        let blob = new Blob([fileBlob], {
          type: 'application/vnd.ms-excel'
        })
        return blob;
      })
      .catch(this.handleError)

  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/util.service.ts